import { satelliteTracker } from '../../../../services/tracking/satellite-tracking-service';
import { getDomainName } from '../../../../utils/aem-utils';

const TRACKING_EVENT = 'personalizzazione_contenuto';
const FALLBACK_TRACKING_OPTIONS = null;

export const trackUserPreferences = (options) => {
  const trackingOptions =
    options?.map((option) => `${getDomainName()}-${option.name}`).join('|') || FALLBACK_TRACKING_OPTIONS;
  satelliteTracker.trackInWeb(TRACKING_EVENT, { name: trackingOptions });
};
